import ApiResponse from "../types/IApiResponse";

const handleApiResponse = <T>(response: ApiResponse<T>, onSuccess: (data: T) => void, onError: (error: any) => void) => {
  if (response.statusCode === '200' && response.isSuccess) {
    onSuccess(response.data);
  } else {
    onError(response.error);
  }
}

export default handleApiResponse;
